import apiClient from '../utils/apiClient';

export const orderApprovalAPI = {
  getDeletionRequests: async (params = {}) => {
    return await apiClient.get({
      url: '/orders/approval-requests',
      params,
    });
  },

  getByOrderId: async (orderId) => {
    return await apiClient.get({
      url: '/orders/approval-requests',
      params: { orderId, limit: 50 },
    });
  },

  approve: async (id) => {
    return await apiClient.put({ url: `/orders/approval-requests/${id}/approve` });
  },

  reject: async (id, reason) => {
    return await apiClient.put({
      url: `/orders/approval-requests/${id}/reject`,
      data: { reason },
    });
  },
};
